import React from 'react'
import classNames from 'classnames'
import { Icon, IconSize } from '@/components/atoms'

type BadgeProps = {
    icon: string
    text: string
    iconSize?: IconSize
    className?: string
    iconClassName?: string
}

export const Badge: React.FC<BadgeProps> = ({
    icon,
    text,
    iconSize = 'small',
    className,
    iconClassName = '',
}) => (
    <span
        data-testid="badge"
        className={classNames(
            'inline-flex h-7 items-center gap-0.5 rounded-lg bg-blue-50 px-2 font-medium text-blue-600',
            className
        )}
    >
        <Icon
            name={icon}
            size={iconSize}
            className={classNames('block', iconClassName)}
        />
        <div className="text-label-small">{text}</div>
    </span>
)
